export default "__VITE_ASSET__CtVaHFd$__"